import Vue from 'vue';
import apiErrorFormatter from './ApiErrorFormatter';
import store from '../../store';
import RouteConstants from '../../routes/Constants';
import SecurityUtil from "../../util/SecurityUtil";
import AppUtil from "../../util/AppUtil";
export default {
    success (response) {
        AppUtil.applyVersion(response.headers[AppUtil.FRONTEND_VERSION_HEADER]);
        return response;
    },
    error (error) {
        AppUtil.applyVersion(error.response.headers[AppUtil.FRONTEND_VERSION_HEADER]);
        if (error.response.status === 401 || error.response.status === 403) {
            SecurityUtil.removeToken();
            store.commit('resetState');
            //window.localStorage.removeItem('token');
            if (window.Router.currentRoute.name !== RouteConstants.LOGIN && !window.Router.currentRoute.meta.no_session) {
                window.Router.push({ name : RouteConstants.LOGIN });
            }
        } else if (error.response.status >= 500) {
            Vue.prototype.$notify({
                text : apiErrorFormatter(error.response.data, 'Something went wrong and we were unable to process your request, if this keeps happening please contact us.'),
                type : 'error',
                duration : 150000
            })
        }
        // return error
        return Promise.reject(error.response);
    }
}
